export const APP_BASE = "/tokenomics";
export const API_BASE = `${APP_BASE}/api`;
export const MAC_APP_DOWNLOAD_URL = "https://ai.candobear.com/tokenomics/downloads/mac/latest";
export const BRAND_LOGO_URL = `${APP_BASE}/brand/candobear-logo.png`;

export const DAILY_TOKEN_GOAL = 100_000_000;
export const YEARLY_TOKEN_GOAL = 100_000_000_000;
export const TOTAL_TOKEN_MILESTONES = [
  { value: 3_000_000_000, label: "30 亿", caption: "基础 agent 体验" },
  { value: 10_000_000_000, label: "100 亿", caption: "稳定高频使用" },
  { value: 30_000_000_000, label: "300 亿", caption: "深度实践" },
  { value: 100_000_000_000, label: "1000 亿", caption: "长期目标" },
];

export const providerOptions = [
  { value: "all", label: "合计" },
  { value: "codex", label: "Codex" },
  { value: "claude", label: "Claude Code" },
];

export const leaderboardModeOptions = [
  { value: "day", label: "日" },
  { value: "week", label: "周" },
  { value: "month", label: "月" },
  { value: "quarter", label: "季" },
  { value: "year", label: "年" },
  { value: "total", label: "总量" },
];
